import React from 'react'
import { StyleSheet } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { MotiView } from '@zet/common/components/motiView'
import {
  B2,
  B5,
  Button,
  Icon,
  SH1,
  SH3,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

// import { useExperiments } from '@zet/experiments'
// import { navigationRef } from '@zet/utils/navigation'
import { ZetCoinOutlinedBlack, ZetCoinOutlinedWarn } from '../../assets'
// import UseZetCoins from '../../components/zetStore/useZetCoins'
import { getAgentPointsTypes } from '../../types'
import { i18n } from '../localization'

type RedeemCoinsSection = {
  currectSection: string
  setCurrentSection: (value: string) => void
  setIsRedeemBottomSheetOpen: (value: boolean) => void
  data?: getAgentPointsTypes
}

const RedeemCoinsSection = ({
  currectSection,
  setCurrentSection,
  setIsRedeemBottomSheetOpen,
  data,
}: RedeemCoinsSection) => {
  // const [isZetStoreSeleted, setIsZetStoreSeleted] = useState(true)
  // const { data: experiment } = useExperiments()

  const closeBottomSheet = () => {
    setIsRedeemBottomSheetOpen(false)
  }

  const setNextSection = () => {
    // if (isZetStoreSeleted) {
    //   navigationRef.navigate('ZetStoreWebView')
    //   setIsRedeemBottomSheetOpen(false)
    //   publishEvent('click_action', {
    //     item_name: 'coins_ledger_continue_selection',
    //     feature: 'coins_ledger',
    //     option_selected: 'zet_store',
    //   })
    // } else {
    setCurrentSection('ConvertCoinsSection')
    publishEvent('click_action', {
      item_name: 'coins_ledger_continue_selection',
      feature: 'coins_ledger',
      option_selected: 'cash',
    })
    // }
  }

  // useEffect(() => {
  //   if (experiment?.UI_isZetStore) {
  //     setIsZetStoreSeleted(true)
  //   } else {
  //     setIsZetStoreSeleted(false)
  //   }
  // }, [])

  return (
    <MotiView
      from={{ opacity: 0 }}
      animate={{ opacity: currectSection === 'UseCoinsSection' ? 1 : 0 }}
      transition={{ duration: 100, type: 'timing' }}
    >
      <XStack className="w-full items-center justify-between p-3">
        <XStack className="items-center gap-x-2">
          <ZetCoinOutlinedBlack height={24} width={24} />
          <SH1 className="ml-2">{i18n.t('coinsLedger.cta.useYourCoins')}</SH1>
        </XStack>
        <Pressable onPress={closeBottomSheet}>
          <Icon
            className="mx-1"
            type="Close"
            color={zetColors.neutral.black100}
          />
        </Pressable>
      </XStack>
      <Stack className="border-grays-30 border-t p-3">
        <B2>{i18n.t('coinsLedger.bottomsheet.howYouWantToUse')}</B2>

        {/* {experiment?.UI_isZetStore ? (
          <UseZetCoins
            data={data}
            title={i18n.t('coinsLedger.bottomsheet.shopOnZETStore')}
            func={() => {
              setIsZetStoreSeleted(true)
            }}
            controller={isZetStoreSeleted}
            value={data?.conversionRate?.toZetStore}
          />
        ) : (
          <XStack className="bg-grays-20 mt-3 items-center p-2">
            <LockOutLined />
            <YStack className="pl-3">
              <XStack>
                <SH3>{i18n.t('redeemPoints.shopOnZet')}</SH3>
                <CTN className="bg-decorative-bee100 ml-3 rounded-xl px-2 py-1">
                  {i18n.t('redeemPoints.comingSoon')}
                </CTN>
              </XStack>
            </YStack>
          </XStack>
        )} */}

        {/* <UseZetCoins
          data={data}
          title={i18n.t('coinsLedger.bottomsheet.convertToCash')}
          func={() => {
            setIsZetStoreSeleted(false)
          }}
          controller={!isZetStoreSeleted}
          value={data?.conversionRate?.toCash}
        /> */}

        <XStack className="bg-grays-20 mb-2 mt-1 items-center rounded py-2">
          <Stack className="p-2">
            <Icon size={25} type="RadioOn" color={zetColors.primary[150]} />
          </Stack>

          <Stack className="gap-1">
            <SH3>{i18n.t('coinsLedger.bottomsheet.convertToCash')}</SH3>
            <B5>
              {i18n.t('coinsLedger.strings.convertZetCoinsTo', {
                amount: data?.conversionRate?.toCash,
              })}
            </B5>
          </Stack>
        </XStack>

        {!data?.isRedeemable && data?.errorString ? (
          <XStack
            className="mb-2 items-center rounded p-2"
            style={styles.errorMessageView}
          >
            <ZetCoinOutlinedWarn />
            <B5 className="ml-2 self-center">{data?.errorString}</B5>
          </XStack>
        ) : (
          <></>
        )}

        <Stack className="py-2">
          <Button
            size="lg"
            fullWidth
            onPress={setNextSection}
            disabled={!data?.isRedeemable}
          >
            {i18n.t('coinsLedger.cta.continue')}
          </Button>
        </Stack>
      </Stack>
    </MotiView>
  )
}

const styles = StyleSheet.create({
  zetStoreContainer: { backgroundColor: '#FFB000' },
  errorMessageView: { backgroundColor: '#FFF0E1' },
})

export { RedeemCoinsSection }
